import React, { lazy, useState } from 'react';
import './App.css';
import { environment } from './environment';
import { Provider } from 'react-redux';
import { AppInit, INavLink, ConsentManager } from '@hwm/ui-lib';
import store from './store/store';
import theme from '@styles/theme';
import { styleConstants } from '@styles/constants';
import { actionInterceptor } from './store/middleware/actionsInterceptorMiddleware';
import { userProfileReducer } from './store/library-stores/user-profile';
import { AppPaths } from '@infrastructure/routes/routesPaths';
import { MainMenu } from '@shared/components/MainMenu';
import { UserDetails } from '@shared/components/UserDetails';
import { Trans } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';


const LazyLayout = lazy(() => import('./shared/components/Layout'));
const consentTexts = {
  banner: {
    description: (
        <Trans>
          We use cookies to improve your experience. You can accept all cookies, reject non-essential cookies, or manage
          your preferences.
        </Trans>
    ),
    acceptAll: <Trans>Accept All</Trans>,
    rejectAll: <Trans>Reject All</Trans>,
    preferences: <Trans>Preferences</Trans>,
  },
  modal: {
    title: <Trans>Cookie Preferences</Trans>,
    analyticsLabel: <Trans>Analytics (Microsoft Clarity)</Trans>,
    analyticsDescription: (
        <Trans>
          Allows us to understand how visitors use our site to improve UX. No personal data is sold or shared outside our
          organization.
        </Trans>
    ),
    save: <Trans>Save Preferences</Trans>,
    cancel: <Trans>Cancel</Trans>,
  },
};

export const AppComponent: React.FC = () => {
  const [links, setLinks] = useState<INavLink[]>([]);

  return (
    <I18nProvider i18n={i18n as any} forceRenderOnLocaleChange={false}>
      <Provider store={store}>
        <ConsentManager clarityId={environment.clarityId} texts={consentTexts}>
          {AppInit({
            LazyLayout: LazyLayout,
            actionInterceptor: actionInterceptor as any,
            applicationPaths: AppPaths,
            styleConstants: styleConstants,
            theme: theme,
            additionalConfig: {
              authority: environment.authority,
              clientId: environment.clientId,
              scope: environment.scope,
              silentLoginTimeout: environment.silentLoginTimeout,
            },
            initialLayoutProps: {
              appName: ['Spill', 'Guard'],
              customButtons: [<MainMenu links={links} setLinks={setLinks} />, <UserDetails />],
              links: links,
              className: '',
              sessionConfig: {
                sessionCookieDomain: environment.sessionCookieDomain,
                sessionCookieIsSecure: environment.sessionCookieSecure,
                sessionIdleTimeout: environment.sessionCookieIdleTimeout,
              },
              accountHierarchyReset: false,
              // additional state
              sidebarState: true,
              sidebarShowData: false,
              sidebarListContext: 'Sites',
            },
            redirectEmptyUrl: '/sitemap',
            setOidcUser: (oidcUser) => {
              store.dispatch(userProfileReducer.slice.actions.setOidcUser(oidcUser));
            },
          })}
        </ConsentManager>
      </Provider>
    </I18nProvider>
  );
};
